<script setup lang="ts">
import {useCookieBanner} from '@/composables/www/useCookieBanner'

/**
 * Paid-landing chrome: copyright + a link back to the full site + Privacy + Terms + cookie
 * preferences only. Opt in with route meta `landingChrome`. Do not use the site Footer here.
 */
const {open: openCookieBanner} = useCookieBanner()
</script>

<template>
  <footer class="landing-footer" data-landing-footer>
    <div class="landing-footer__inner">
      <p class="landing-footer__copy">&copy; 2026 Osello Corp. All rights reserved.</p>
      <nav class="landing-footer__nav" aria-label="Footer">
        <RouterLink class="landing-footer__link" to="/" data-visit-full-website>Visit full website</RouterLink>
        <RouterLink class="landing-footer__link" to="/legal/privacy-policy">Privacy Policy</RouterLink>
        <RouterLink class="landing-footer__link" to="/legal/terms-of-service">Terms of Service</RouterLink>
        <button type="button" class="landing-footer__link" data-cookie-preferences @click="openCookieBanner">
          Cookie preferences
        </button>
      </nav>
    </div>
  </footer>
</template>

<style scoped>
.landing-footer {
    background-color: var(--secondary-700);
    color: rgba(255, 255, 255, 0.5);
    padding-block: var(--space-10);
}

.landing-footer__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-7);
    max-width: var(--container-page-lg);
    margin-inline: auto;
    padding-inline: var(--container-gutter);
}

.landing-footer__copy {
    margin: 0;
    font-family: var(--font-body);
    font-size: 14px;
}

.landing-footer__nav {
    display: flex;
    align-items: center;
    gap: var(--space-7);
}

.landing-footer__link {
    padding: 0;
    background: none;
    border: 0;
    cursor: pointer;
    font-family: var(--font-body);
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    transition: color 200ms var(--ease-out);
}

@media (hover: hover) and (pointer: fine) {
    .landing-footer__link:hover {
        color: var(--text-white);
    }
}

.landing-footer__link:focus-visible {
    outline: 2px solid var(--focus);
    outline-offset: 4px;
    border-radius: 4px;
}

@media (max-width: 640px) {
    .landing-footer__inner {
        flex-direction: column;
        align-items: flex-start;
    }

    /* One link per line, so each stays an easy tap target. */
    .landing-footer__nav {
        flex-direction: column;
        align-items: flex-start;
        gap: var(--space-5);
    }
}

@media (prefers-reduced-motion: reduce) {
    .landing-footer__link {
        transition: none;
    }
}
</style>
